import React from 'react';
import { ThemeProvider } from 'styled-components';
import { tokens, darkTokens } from './tokens';

/**
 * VedicThemeProvider wraps vedic astrology pages with design tokens.
 * Styled-components in vedic pages access tokens via `props.theme.*`.
 *
 * Usage:
 *   <VedicThemeProvider>
 *     <FreeKundli />
 *   </VedicThemeProvider>
 *
 *   <VedicThemeProvider mode="dark">
 *     <TodayPanchangam />
 *   </VedicThemeProvider>
 *
 * In styled-components:
 *   color: ${p => p.theme.colors.primary};
 *   padding: ${p => p.theme.spacing[4]}px;
 */
export default function VedicThemeProvider({ children, mode }) {
  const theme = mode === 'dark' ? darkTokens : tokens;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
